import * as learningApi from '../../api/learningApi';
import { getVideos } from '../slices/learningSlice';

export const loadVideos = () => {
  return async (dispatch) => {
    const res = await learningApi.loadVideos();
    dispatch(getVideos({ videos: res }));
  };
};
